import { Field, SelectField, SettingsCard } from "./ui";

const FIELDS = [
  ["store_name", "Nome da loja", "text"],
  ["cnpj", "CNPJ", "text"],
  ["ie", "Inscrição Estadual", "text"],
  ["address", "Endereço", "text"],
  ["whatsapp", "WhatsApp (55DDDNÚMERO)", "text"],
  ["free_shipping_min", "Frete grátis a partir de (R$)", "number"],
  ["stock_min_alert", "Alerta de estoque mínimo (un.)", "number"],
  ["commission_default", "Comissão padrão (%)", "number"],
];

export default function StoreTab({ form, setField }) {
  return (
    <SettingsCard title="Dados da loja">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {FIELDS.map(([k, label, type]) => (
          <Field key={k} label={label} type={type} step="0.01" value={form[k]} onChange={(v) => setField(k, v)} testId={`settings-${k}`} />
        ))}
        <SelectField
          label="Regime tributário"
          value={form.regime}
          onChange={(v) => setField("regime", v)}
          testId="settings-regime"
          options={[["simples_nacional", "Simples Nacional"], ["lucro_presumido", "Lucro Presumido"]]}
        />
      </div>
      <p className="text-xs text-slate-400 mt-4">Contas admin/vendedor/balcão são criadas em “Vendedores &amp; Balcão”; clientes se cadastram na loja.</p>
    </SettingsCard>
  );
}
